import { Actions } from '@components/shared/Actions'
import { EyeIcon } from '@assets/svgs/EyeIcon'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { UserItemProps } from '../context/types'

interface ParseNotFeedProps {
  data: UserItemProps[]
  onSeeMore: (data: UserItemProps) => void
}

export const parseUsersGrid = ({ data, onSeeMore }: ParseNotFeedProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'id',
      columnName: 'ID',
      value: item.id || '-',
      align: 'center',
      sortable: true,
      minWidth: '4rem'
    },
    {
      id: 'code',
      columnName: 'Código',
      align: 'center',
      value: item.code || '-',
      sortable: true,
      minWidth: '8rem'
    },
    {
      id: 'name',
      columnName: 'Nome do Usuário',
      align: 'center',
      value: item.name || '-',
      sortable: true,
      minWidth: '18rem'
    },
    {
      id: 'email',
      columnName: 'E-mail',
      align: 'center',
      value: item.email || '-',
      sortable: true,
      minWidth: '14rem'
    },
    {
      id: 'position',
      columnName: 'Cargo',
      align: 'center',
      value: item.position,
      sortable: true,
      minWidth: '18rem'
    },
    {
      id: 'profileDescription',
      columnName: 'Descrição do Perfil',
      align: 'center',
      value: item.profileDescription || '-',
      sortable: true,
      minWidth: '18rem'
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: <Actions actions={[{ label: 'Ver mais', icon: <EyeIcon />, onClick: () => onSeeMore(item) }]} />
    }
  ])

  return parsedData
}
